import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export const ReferenceImage = ({ filename, alt = "", className, style }) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile(filter: { relativeDirectory: { eq: "references" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(
                  maxWidth: 720
                  quality: 80
                  sizes: "(min-width: 768px) 440px, calc(100vw - 80px)"
                ) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.images.edges.find(n =>
        n.node.relativePath.endsWith(filename)
      )
      if (!image) return null
      return (
        <Img
          className={className}
          style={style}
          fluid={image.node.childImageSharp.fluid}
          alt={alt}
        />
      )
    }}
  />
)
